import { useT } from '../../i18n';
import { Dialog } from '../../ui/Dialog';
import styles from './CommentSheet.module.css';

/** Was gelöscht werden soll — bestimmt nur den Wortlaut, nicht das Verhalten. */
export type LoeschArt = 'video' | 'photo' | 'audio' | 'handwriting';

/**
 * Rückfrage vor dem Wegräumen einer Aufnahme.
 *
 * **Wozu.** Der Papierkorb an einer Aufnahme lag bis zum 2026-09-13 einen Tipp von ihrem Ende
 * entfernt — mitten in einer Prüfung, auf einem liegenden iPad, neben dem Knopf zum Abspielen.
 * Der Nutzer hat die Rückfrage für **alle** Aufnahmearten verlangt, nicht nur für das Video:
 * es ist derselbe Fehlgriff an vier Stellen.
 *
 * ⚠️ **Sie sagt, was wirklich geschieht.** Die Datei wird archiviert, nicht gelöscht
 * (`mediaRemove.ts` → `platform/archive.ts`) — wer den Satz „wird endgültig gelöscht" läse und
 * die Datei später im Archiv fände, misstraute künftig jeder Meldung der App. Die Handschrift
 * ist der eine Fall **ohne** Archiv: sie liegt als Strichliste im Bogen, nicht als Datei, und
 * ist nach dem Verwerfen wirklich weg. Deshalb ein eigener Satz dafür.
 */
export function LoeschAufnahmeDialog({
  art,
  beschreibung,
  onConfirm,
  onClose,
}: {
  art: LoeschArt;
  /** Welche Aufnahme genau — Uhrzeit, Dauer, Anzahl. Steht als zweite Zeile im Blatt. */
  beschreibung: string;
  onConfirm: () => void;
  onClose: () => void;
}) {
  const t = useT();

  return (
    <Dialog kicker={t.comment.deleteKicker} title={t.comment.deleteTitle[art]} onClose={onClose} width={420}>
      <p className={styles.deleteBody}>{beschreibung}</p>
      <p className={styles.deleteBody}>
        {art === 'handwriting' ? t.comment.deleteGone : t.comment.deleteArchived}
      </p>
      <div className={styles.deleteButtons}>
        <button type="button" className={`tap ${styles.deleteCancel}`} onClick={onClose}>
          {t.comment.deleteCancel}
        </button>
        <button
          type="button"
          className={`tap ${styles.deleteConfirm}`}
          onClick={() => {
            onConfirm();
            onClose();
          }}
        >
          {t.comment.deleteConfirm}
        </button>
      </div>
    </Dialog>
  );
}
